import React from 'react';

import { clsx } from '@components/Provider';

import { LeftSideCommonProps } from './ChatList/types';
import { makeStyles } from '@material-ui/core';
import { useLocation } from 'react-router-dom';

interface Props extends Pick<LeftSideCommonProps, 'route'> {
  children?: React.ReactNode;
}

const LeftSideListLayout = React.forwardRef<HTMLDivElement, Props>(
  ({ children }, ref) => {
    const { pathname } = useLocation();
    const classes = useStyles();

    const current = pathname.includes('/dashboard') ? 'RFQ' : 'CHAT';

    return (
      <div
        tabIndex={1}
        ref={ref}
        className={clsx(classes.root, {
          'rfq': current === 'RFQ',
          'chat': current === 'CHAT'
        })}
      >
        {children}
      </div>
    );
  }
);

export default LeftSideListLayout;

const CHAT_LIST_FILTER_HEIGHT = 120;
const LIST_HEADER_HEIGHT = 68;
const RFQ_FILTER_HEIGHT = 120;
const GNB_HEIGHT = 61;
const LEFT_BOTTOM_NAV_HEIGHT = 56;
const PAYMENT_BANNER = 90;

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: `calc(100vh - ${GNB_HEIGHT + LIST_HEADER_HEIGHT}px)`,
      overflow: 'scroll',
      '&.rfq': {
        position: 'relative',
        height: `calc(var(--vh , 1vh) * 100 - ${
          RFQ_FILTER_HEIGHT + LIST_HEADER_HEIGHT + GNB_HEIGHT + PAYMENT_BANNER
        }px)`
      },
      '&.chat': {
        height: `calc(var(--vh , 1vh) * 100 - ${
          CHAT_LIST_FILTER_HEIGHT + LIST_HEADER_HEIGHT + GNB_HEIGHT
        }px)`
      },

      [theme.breakpoints.down('md')]: {
        '&.rfq': {
          height: `calc(var(--vh , 1vh) * 100 - ${
            RFQ_FILTER_HEIGHT +
            LIST_HEADER_HEIGHT +
            LEFT_BOTTOM_NAV_HEIGHT +
            PAYMENT_BANNER
          }px)`
        },
        '&.chat': {
          height: `calc(var(--vh , 1vh) * 100 - ${
            LIST_HEADER_HEIGHT +
            CHAT_LIST_FILTER_HEIGHT +
            LEFT_BOTTOM_NAV_HEIGHT
          }px)`
        }
      }
    }
  }),
  {
    classNamePrefix: 'dashboard-left'
  }
);
